import React from 'react';
import { faPaperclip } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import Carousel from 'react-bootstrap/lib/Carousel';
import Image from 'react-bootstrap/lib/Image';
import FontIcomoonIcon from '../FontIcomoonIcon';

class WebTemplatesPreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      images: this.props.images,
      indexSelected: 1,
    };

    this.onNext = this.onNext.bind(this);
  }

  onPaginationClick = (index) => {
    this.setState({ indexSelected: index });
  };

  onNext = () => {
    const { indexSelected } = this.state;
    const maxIndex = this.state.images.length - 1;

    if (indexSelected >= maxIndex) {
      return this.setState({ indexSelected: 1 });
    }

    this.setState({ indexSelected: indexSelected + 1 });
  };

  onPrevious = () => {
    const { indexSelected } = this.state;
    const maxIndex = this.state.images.length - 1;

    if (indexSelected <= 1) {
      return this.setState({ indexSelected: maxIndex });
    }

    this.setState({ indexSelected: indexSelected - 1 });
  };

  render() {
    const { images, indexSelected } = this.state;

    return (
      <div className="web-preview">
        {images.length === 1 && (
          <div style={{ justifyContent: 'center' }}>
            <Image
              className="img-responsive"
              src={images[0].path}
              responsive
              style={{ maxWidth: '100%' }}
            />
          </div>
        )}
        {images.length > 1 && (
          <div className="web-wrapper">
            <div className="web-section-left">
              <div className="text-center">
                <FontAwesomeIcon
                  style={{
                    width: 15,
                    transform: 'rotate(100deg)',
                  }}
                  icon={faPaperclip}
                />{' '}
                {images.length - 1} Files set
              </div>
              <div className="web-pagination">
                {images.map((item, index) => {
                  if (index === 0) return;
                  return (
                    <div
                      key={index}
                      className="web-pagination-item-wrapper"
                      onClick={() => {
                        this.onPaginationClick(index);
                      }}
                    >
                      <div className="web-pagination-item">
                        <img
                          className="web-thumbnail-responsive"
                          src={item.thumbnail}
                        />
                      </div>
                      <div className="web-pagination-hover">
                        <FontIcomoonIcon icon="icon-search" fixedWidth />
                      </div>
                      {index === indexSelected && (
                        <div className="current-thumbnail-arrow">
                          <FontIcomoonIcon icon="icon-right-arrow" fixedWidth />
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="web-section-right">
              <div className="web-detail">
                <div className="scrollbar" id="style-3">
                  <div className="force-overflow">
                    <div className="web-pagination-item">
                      <Carousel
                        activeIndex={indexSelected}
                        onSelect={this.onNext}
                        direction="next"
                        controls={false}
                      >
                        {images.map((item, key) => (
                          <Carousel.Item
                            key={key}
                            onClick={this.onNext}
                            style={{ cursor: 'pointer' }}
                          >
                            <img
                              width="100%"
                              style={{ maxWidth: 750 }}
                              className="img-responsive"
                              src={`${item.path}`}
                            />
                          </Carousel.Item>
                        ))}
                      </Carousel>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="web-section-right-mobile">
              <div className="web-detail-mobile">
                <div className="left-icon" onClick={this.onPrevious}>
                  <FontIcomoonIcon
                    style={{ transform: 'rotate(180deg)' }}
                    fixedWidth={false}
                    icon="icon-register-arrow-right"
                  />
                </div>
                <div className="scrollbar" id="style-3">
                  <div className="force-overflow">
                    <div className="web-pagination-item">
                      <Carousel
                        activeIndex={indexSelected}
                        onSelect={this.onNext}
                        direction="next"
                        controls={false}
                      >
                        {images.map((item, key) => (
                          <Carousel.Item
                            key={key}
                            onClick={this.onNext}
                            style={{ cursor: 'pointer' }}
                          >
                            <img
                              width="100%"
                              style={{ maxWidth: 750 }}
                              className="img-responsive"
                              src={`${item.path}`}
                            />
                          </Carousel.Item>
                        ))}
                      </Carousel>
                    </div>
                  </div>
                </div>
                <div className="right-icon" onClick={this.onNext}>
                  <FontIcomoonIcon
                    icon="icon-register-arrow-right"
                    fixedWidth={false}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        <style jsx>
          {`
            .web-preview .web-wrapper {
              display: flex;
              flex-wrap: wrap;
              padding: 15px 10px 15px 0;
            }
            .web-preview .web-wrapper .web-section-left {
              width: 150px;
              margin-right: 42px;
              margin-top: -20px;
            }
            .web-preview .web-wrapper .web-section-right-mobile {
              display: none;
            }
            .web-preview .web-wrapper .web-detail-mobile {
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .web-preview .web-wrapper .web-detail-mobile .left-icon,
            .web-preview .web-wrapper .web-detail-mobile .right-icon {
              font-size: 30px;
              margin: 0 10px;
              color: #ffa823;
              cursor: pointer;
              display: inline-block;
              user-select: none;
            }
            .web-preview .web-wrapper .carousel-indicators {
              display: none;
            }
            @media only screen and (max-width: 770px) {
              .web-preview .web-wrapper .web-section-right-mobile {
                display: block;
              }
            }
            @media only screen and (max-width: 990px) {
              .web-preview .web-wrapper .web-section-left {
                width: 90px;
              }
            }
            @media only screen and (max-width: 770px) {
              .web-preview .web-wrapper .web-section-left {
                display: none;
              }
            }
            @media only screen and (max-width: 770px) {
              .web-preview .web-wrapper .web-section-right {
                display: none;
              }
            }
            .web-preview .web-wrapper .web-section-right {
              flex: 1;
              margin-top: -15px;
              background-color: #f5f5f5;
            }
            .web-preview .web-wrapper .web-pagination {
              margin-top: -10px;
            }
            .web-preview
              .web-wrapper
              .web-pagination
              .web-pagination-item-wrapper {
              position: relative;
            }
            .web-preview
              .web-wrapper
              .web-pagination
              .web-pagination-item-wrapper:hover
              .web-pagination-hover {
              opacity: 1;
            }
            .web-preview .web-wrapper .web-pagination .web-pagination-hover {
              display: flex;
              top: 0;
              width: 100%;
              height: 100%;
              color: #fff;
              font-size: 35px;
              cursor: pointer;
              opacity: 0;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              position: absolute;
              -webkit-transition: opacity 0.5s;
              -moz-transition: opacity 0.5s;
              -ms-transition: opacity 0.5s;
              -o-transition: opacity 0.5s;
              transition: opacity 0.5s;
              background-color: rgba(29, 29, 29, 0.5);
            }
            .web-preview .web-wrapper .web-pagination .web-pagination-item {
              margin: 25px 0;
              padding: 0;
              overflow: hidden;
              border: 3px solid rgba(0, 0, 0, 0.35);
              height: 150px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              border-radius: 2px;
              box-shadow: -2px -2px 8px grey;
              border-color: white;
            }
            .web-preview
              .web-wrapper
              .web-pagination
              .web-pagination-item
              .web-thumbnail-responsive {
              width: 100%;
            }
            .web-preview .web-wrapper .web-detail {
              padding: 5px;
              border-radius: 2px;
              flex: 1;
              align-items: center;
              justify-content: center;
              background-color: white;
            }
            .web-preview .web-wrapper .web-detail .left-icon,
            .web-preview .web-wrapper .web-detail .right-icon {
              width: 50px;
              font-size: 40px;
              margin: 0 15px;
              color: #ffa823;
              cursor: pointer;
              display: inline-block;
              user-select: none;
            }
            .web-preview .web-wrapper .web-detail .web-container {
              justify-content: center;
              height: 100%;
              display: flex;
              flex-direction: column;
            }
            .web-preview .web-wrapper .web-detail .carousel-indicators {
              display: none;
            }
          `}
        </style>
      </div>
    );
  }
}

WebTemplatesPreview.propTypes = {
  images: PropTypes.array,
};

WebTemplatesPreview.defaultProps = {
  images: [
    {
      path:
        'https://data.photo-ac.com/data/thumbnails/c4/c4d3c0c4cbde624f79ce903e8d724964_w.jpeg',
      thumbnail:
        'https://data.photo-ac.com/data/thumbnails/c4/c4d3c0c4cbde624f79ce903e8d724964_w.jpeg',
    },
    {
      path:
        'https://data.photo-ac.com/data/thumbnails/ed/ed6214f7b43378dfae8cfff052604a24_w.jpeg',
      thumbnail:
        'https://data.photo-ac.com/data/thumbnails/ed/ed6214f7b43378dfae8cfff052604a24_w.jpeg',
    },
    {
      path:
        'https://data.ac-illust.com/data/thumbnails/3d/3d300dd9952e45997b8d130f5002a52a_t.jpeg',
      thumbnail:
        'https://data.ac-illust.com/data/thumbnails/3d/3d300dd9952e45997b8d130f5002a52a_t.jpeg',
    },
  ],
};

export default WebTemplatesPreview;
